import contracts from "./contracts";
import files from "./files";
import forms from "./forms";

export default {
    contracts,
    files,
    forms,
};
